import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, query, orderBy } from "firebase/firestore";
import "../../css/OrderTracking.css";

function OrderTracking() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const user = auth.currentUser;
        if (!user) {
          alert("Please log in to track your orders.");
          setLoading(false);
          return;
        }

        // 🔹 Get orders for logged-in user, sorted by created date
        const ordersRef = collection(db, "users", user.uid, "orders");
        const q = query(ordersRef, orderBy("createdAt", "desc"));
        const snapshot = await getDocs(q);

        const orderList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setOrders(orderList);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [auth, db]);

  if (loading) return <p>Loading your orders...</p>;

  return (
    <div className="order-tracking">
      <h2>My Orders</h2>
      {orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        orders.map((order) => (
          <div key={order.id} className="order-card">
            <h3>Order ID: {order.orderId}</h3>
            <p><strong>Status:</strong> {order.status}</p>
            <p><strong>Total:</strong> Rs.{order.total.toLocaleString("en-LK")}</p>
            <p>
              <strong>Date:</strong>{" "}
              {order.createdAt?.toDate
                ? order.createdAt.toDate().toLocaleString()
                : "Pending"}
            </p>
            <h4>Items:</h4>
            <ul>
              {order.items.map((item, index) => (
                <li key={index}>
                  {item.title} × {item.quantity} (Rs.{item.price})
                </li>
              ))}
            </ul>
          </div>
        ))
      )}
    </div>
  );
}

export default OrderTracking;
